import AreaLimit from './AreaLimit.vue'

export default AreaLimit
